import {IWixStatic} from '@wix/yoshi-flow-editor'
import {EditorSDK} from '@wix/platform-editor-sdk'

export const getOrigCompRef = (Wix: IWixStatic, editorSDK: EditorSDK) => {
  const compId = Wix.Utils.getOrigCompId()
  return editorSDK.document.components.getById('token', {id: compId})
}
